/* eslint-disable react/destructuring-assignment */
import React from "react";
import { string } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";

const DataRemoveService = (props) => {
    const { company = props.company, reference = props.reference, paymentCode = props.paymentCode } = props;
    return (
        <GridTable className="deposit-summary form-summary">
            <GridTable.Container columns={3} rows={4}>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleTextType="I18N"
                        titleText="adheredServices.business"
                        valueText={company}
                        valueClass="data-label"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={1}>
                    <CustomData
                        titleTextType="I18N"
                        titleText="adheredService.reference.label"
                        valueText={reference}
                        valueClass="data-label"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={1}>
                    <CustomData
                        titleTextType="I18N"
                        titleText="adheredServices.paymentCode"
                        valueText={<CustomText className="data-label" text={paymentCode} />}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

DataRemoveService.propTypes = {
    company: string,
    reference: string,
    paymentCode: string,
};

DataRemoveService.defaultProps = {
    company: "",
    reference: "",
    paymentCode: "",
};

export default DataRemoveService;
